import { render, staticRenderFns } from "./header-checkout-offer.vue?vue&type=template&id=196e118d&"
import script from "./header-checkout-offer.vue.ts?vue&type=script&lang=ts&"
export * from "./header-checkout-offer.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports